import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// env
import { environment } from './../../../environments/environment';

// Plugin
import { Lightbox } from 'ngx-lightbox';
import { LightboxConfig } from 'ngx-lightbox';

// Service
import { ApiService } from '../../shared/service/api.service';
import { GlobalService } from '../../shared/service/global.service';

@Component({
  selector: 'app-gallery-page',
  templateUrl: './gallery-page.component.html',
  styles: [
  ]
})
export class GalleryPageComponent implements OnInit {

  isModalShown = false;
  modalImg:string;
  modalDetail:string;
  modalTitle:string;
  dataBanner;
  _albums = [];
  urlApi;
  btnLoad = true;
  textLoad = 'Load More';
  apiAsset = environment.API_ASSETS;

  constructor(private lightbox: Lightbox, 
              private _lightboxConfig: LightboxConfig,
              private apiService: ApiService,
              private globalService: GlobalService,
              private router: Router) { 
    _lightboxConfig.centerVertically = true;
    _lightboxConfig.disableScrolling = true;
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getSubHeaderByLink/gallery').subscribe(response => {
      if(response.success){
        this.dataBanner = response.data;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // Data Gallery
    this.apiService.getDataApi('getGallery?page=1').subscribe(response => {
      this.getAlbum(response.data);
      this.globalService.isLoading.next(false);
    });
  }

  open(index: number): void {
    // open lightbox
    this.lightbox.open(this._albums, index);
  }
 
  close(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }

  getAlbum(dataGal){
    dataGal.data.map((v, i) => {
      let src = this.apiAsset + v.picture;
      let caption;
      if(v.content){
         caption = '<h6 class="tit">' + v.title + '</h6>' + v.content;
      }else{
        caption = '<h6 class="tit">' + v.title + '</h6>';
      }
      let album; 
      if(v.title){
        album = {
          src: src,
          title: v.title,
          content: v.content,
          picture: v.picture,
          caption: caption
       };
      }else{
        album = {
          src: src,
          title: v.title,
          content: v.content,
          picture: v.picture
        };
      }
      this._albums.push(album);
    });
    this.urlApi = dataGal.next_page_url;
    if(this.urlApi === null){
      this.btnLoad = false;
    }
  }

  getMore(){
    this.textLoad = 'Loading...';
    if(this.urlApi) {
      this.apiService.getNextPage(this.urlApi).subscribe(response => {
        this.getAlbum(response.data);
        this.textLoad = 'Load More';
      });
    }
  }
}
